import {Injectable} from '@angular/core';
import {JsonhelperInterface} from "./jsonhelper.interface";

/**
 * class > HalHelper
 *
 * @desc Helper-Klasse um durch ein nach dem HAL-Format aufgebautes json-Objekt zu navigieren
 */
@Injectable()
export class HalHelper implements JsonhelperInterface{


    /**
     * Function > getEmbeddedRessources
     *
     * @desc gibt die Entities der uebergebenen Entity zurueck
     * @param OBJ_json

     * @return {array}
     */
    public getEmbeddedRessources(OBJ_json)
    {
        // just return first entry - API doesnt return more than one actually anyway
        return OBJ_json._embedded[Object.keys(OBJ_json._embedded)[0]];
    } // end function getEmbeddedRessources



    /**
     * Function > hasProperty
     * @desc Uerbeprueft ob ein property mit dem uebergebenem Namen im uebergebenem Json vorhanden ist
     * @param {string} STR_name
     * @param {object} OBJ_json
     * @return {boolean}
     */
    public hasProperty(STR_name: string, OBJ_json)
    {
        return OBJ_json.hasOwnProperty(STR_name);
    } // end function hasProperty


    /**
     * Function > getProperty
     *
     * @desc Gibt Inhalt des properties mit dem uebergebenen Namen zurueck falls vorhanden, ansonsten undefined
     * @param {string} STR_name
     * @param OBJ_json
     * @return
     */
    public getProperty(STR_name: string, OBJ_json)
    {
        // Durch verschachtelte Objekte navigieren
        while (STR_name.indexOf(".") !== -1)
        {
            // verschachtelte Objecte werden in der Form <objectName>.<propertyName> uebergeben
            let STR_path = STR_name.slice(0,STR_name.indexOf("."));
            // Hole Key des Objekt-Eintrages
            STR_name = STR_name.slice(STR_name.indexOf(".") + 1);
            // Hole Inhalt des Objektes
            OBJ_json = this.getProperty(STR_path, OBJ_json);

        } // end while


        if (OBJ_json && OBJ_json.hasOwnProperty(STR_name))
        {
            return OBJ_json[STR_name];
        }
        else
        {
            return null;
        } // end if

    } // end function getProperty

	/**
	 * Function > getObjectByProperty
	 *
	 * @desc Gibt Inhalt des properties mit dem uebergebenen Namen zurueck falls vorhanden, ansonsten undefined
	 *
	 * @param STR_property_name
	 * @param STR_property_value
	 * @param ARR_json
     * @return
	 */
	public getObjectByProperty(STR_property_name: string, STR_property_value: string, ARR_json)
	{
		for (let OBJ_json_object of ARR_json)
		{
		    if (this.getProperty(STR_property_name, OBJ_json_object) == STR_property_value)
            {
                return OBJ_json_object;
            }

		} // end for

	} // end function getObjectByProperty


    /**
     * Function > updateProperty
     *
     * @desc Setzt Inhalt des properties mit dem uebergebenen Namen auf uebergebenen Wert
     *       Sollte property noch nicht existieren, wird es angelegt
     * @param {string} STR_name
     * @param OBJ_value
     * @param OBJ_json
     */
    public updateProperty(STR_name: string, OBJ_value, OBJ_json)
    {
        if(OBJ_json) {

            OBJ_json[STR_name] = OBJ_value;

        } // end if

    } // end function updateProperty


    /**
     * Function > getProperties
     *
     * @desc Gibt die properties der uebergebenen Entity zurueck
     * @param OBJ_json
     * @return {array}
     */
    public getProperties(OBJ_json)
    {
        return OBJ_json;
    } // end function getProperties


    /**
     * Function > getLinks
     *
     * @desc Gibt die Links der uebergebenen Entity zurueck
     * @param OBJ_json
     * @return {array}
     */
    public getLinks(OBJ_json)
    {
        return OBJ_json._links;
    } // end function getLinks


    /**
     * Function > getLink
     *
     * @desc gibt den Link mit dem uebergebenen rel-Attribute zurueck
     * @param {string} STR_rel
     * @param OBJ_json
     * @return {string}
     */
    public getLinkByRel(STR_rel: string, OBJ_json)
    {
        if(this.getLinks(OBJ_json)[STR_rel])
        {

            return this.getLinks(OBJ_json)[STR_rel].href;
        }
        else
        {
            return null;
        } // end if

    } // end function getLink


    /**
     * Function > getLinkToSelf
     * @desc Gibt Link zum REST-Endpoint der geladenen Daten zurueck
     * @param OBJ_json
     * @return {string} Link zum REST-Endpoint der aktuellen Daten
     */
    getLinkToSelf(OBJ_json)
    {

    	let STR_link = this.getLinkByRel("self", OBJ_json);

    	// Temporaerer Fix, um relative URL zu bekommen, da Api fuer OKD ungueltige URL zurueckgibt
		if(STR_link.startsWith('http://') || STR_link.startsWith('https://'))
		{
			STR_link = STR_link.replace('http://', '');
			STR_link = STR_link.replace('https://', '');

			STR_link = STR_link.slice(STR_link.indexOf('/'));
		} // end if

        return STR_link;
    } // end function getLinkToSelf



} // end class HalHelper
